<div class="title">{{ template.title }}</div>
<app-vendor-banner
  class="preferred-vendor"
  *ngIf="showVendorBanner && template.preferredVendor"
  [compact]="preferredVendorCompact"
  [vendor]="template.preferredVendor"
></app-vendor-banner>
<div
  class="subtitle"
  *ngIf="template.subtitle"
  [innerHTML]="template.subtitle"
></div>
<div class="template-container">
  <div class="lanes">
    <app-visionboard-workspace-template-lane
      *ngFor="let lane of template.lanes"
      class="lane"
      [lane]="lane"
      [showTitle]="multiLaneMode"
      [showBorder]="true"
    ></app-visionboard-workspace-template-lane>
  </div>
</div>
